import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';
import { z } from 'zod/v4';

import { CONTRACTS_MANAGE_PERMISSION, LEASING_CONTRACTS_PATH } from '&/features/leasing/paths';

// SWOOP-346. The trailing underscore un-nests it from `contracts.tsx` (precedent: `contracts_.new.tsx`), and
// the one on `$contractId_` un-nests it from the contract page `contracts_.$contractId.tsx` (SWOOP-345), which
// has no <Outlet/>: nested under it, `/leasing/contracts/<id>/edit` rendered that page instead of the wizard.
// The parent `/leasing` route applies the module switch and `leasing:access`; this one adds
// `contracts:manage`. On a hard refresh permissions may not be loaded yet, so `beforeLoad` lets that
// through and the page checks again once they are. `?step` carries the wizard step across the URL replace
// the first save makes (new → edit), so the user stays where they were.
// `.catch(undefined)` so a bad `?step` (e.g. `abc`, `9`, `1.5`) falls back to the default step instead of
// throwing in `validateSearch` and crashing the route.
const editSearchSchema = z.object({
  step: z.coerce.number().int().min(0).max(3).optional().catch(undefined),
});

export const Route = createFileRoute('/_authenticated/leasing/contracts_/$contractId_/edit')({
  beforeLoad: ({ context }): void => {
    if (context.permissions.isReady && !context.permissions.hasPermission(CONTRACTS_MANAGE_PERMISSION)) {
      throw redirect({ to: LEASING_CONTRACTS_PATH });
    }
  },
  component: lazyRouteComponent(() => import('&/features/leasing/pages/edit-contract-page')),
  staticData: { titleKey: 'leasingEditContract' },
  validateSearch: editSearchSchema,
});
